import {buildUserKey} from './build-user-key';
import {readEncryptedValue} from './encrypted-values';
import {loginId} from './local-storage-vars';

/**
 * @returns the user's decrypted localStorage value for the given key, or `undefined` until `loadEncryptedValues`
 * has decrypted it
 */
export function getForUserEncrypted(key: string) {
    if (loginId) {
        return readEncryptedValue(buildUserKey(loginId, key)) as any;
    }
    return undefined;
}
